import { TAG_TYPES } from '@/lib/api/tags';
import { buildListQueryParams, processListPage, processServerError } from '@/lib/api/listQuery';
import { notifyOnSuccess } from '@/lib/api/notifyOnSuccess';
import {
  BACK_TO_BACK_SEARCH_IN,
  BACK_TO_BACK_SORT_FIELDS,
} from '../constants/backToBackAccounts.constants';
import {
  buildBackToBackAccountDto,
  processBackToBackAccount,
} from '../mappers/backToBackAccountsMappers';

const PATHS = {
  list: '/back-to-back-accounts',
  account: (id) => `/back-to-back-accounts/${id}`,
  generateId: '/back-to-back-accounts/generate-id',
};

const listTag = { type: TAG_TYPES.BackToBackAccount, id: 'LIST' };

export const backToBackAccountsEndpoints = (build) => ({
  getBackToBackAccounts: build.query({
    query: (params) => ({
      url: PATHS.list,
      params: buildListQueryParams(params, {
        sortFields: BACK_TO_BACK_SORT_FIELDS,
        searchIn: BACK_TO_BACK_SEARCH_IN,
      }),
    }),
    transformResponse: (dto) => processListPage(dto, 'accounts', processBackToBackAccount),
    providesTags: (result) =>
      result
        ? [
            ...result.rows.map((row) => ({ type: TAG_TYPES.BackToBackAccount, id: row.id })),
            listTag,
          ]
        : [listTag],
  }),

  generateBackToBackAccountId: build.query({
    query: () => ({ url: PATHS.generateId }),
    transformResponse: (dto) => dto?.output?.accountId ?? '',
  }),

  createBackToBackAccount: build.mutation({
    query: (values) => ({
      url: PATHS.list,
      method: 'POST',
      body: buildBackToBackAccountDto(values),
    }),
    transformErrorResponse: processServerError,
    onQueryStarted: notifyOnSuccess('BACK_TO_BACK_SAVED'),
    invalidatesTags: [listTag],
  }),

  updateBackToBackAccount: build.mutation({
    query: ({ id, values }) => ({
      url: PATHS.account(id),
      method: 'PATCH',
      body: buildBackToBackAccountDto(values),
    }),
    transformErrorResponse: processServerError,
    onQueryStarted: notifyOnSuccess('BACK_TO_BACK_SAVED'),
    invalidatesTags: (result, error, arg) => [
      { type: TAG_TYPES.BackToBackAccount, id: arg.id },
      listTag,
    ],
  }),
});
